import { ModalContext } from 'app/app';
import axios from 'axios';
import { FieldInput } from 'components/fieldInput';
import { ViewContext } from 'components/lib';
import { trailersBodytype, vehiclesBodytype } from 'data';
import { Form, Formik } from 'formik';
import { Fragment, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as Yup from 'yup';
import loaderImage from './images/loader.gif';
import styles from './styles.module.scss';

import InputUtils from 'helpers/inputUtils';

export function TrailerModal() {
  const { id: company_id } = useParams();
  const context = useContext(ViewContext);
  const { modal, setModal } = useContext(ModalContext);
  const [bodyTypeOptions, setBodyTypeOptions] = useState(false);
  const [loading, setLoading] = useState(false);
  const [stated_value, setStatedValue] = useState('');
  const [isNonOwned, setIsNonOwned] = useState(false);

  const inputUtils = new InputUtils();
  const handleChangeStatedValue = (event, handleChange) => {
    handleChange(event);
    event.target.value = event.target.value
      .replaceAll(/\D/g, '')
      .replace(/\?.*/g, ".'");
    setStatedValue(inputUtils.currency(event.target.value));
  };

  useEffect(() => {
    if (modal.data && modal.data.stated_value) {
      setStatedValue(inputUtils.currency(modal.data.stated_value));
    } else {
      setStatedValue('');
    }
  }, [modal]);

  const firstValidationSchema = Yup.object().shape({
    vin: Yup.string()
      .matches(/^[A-Z0-9\s]*$/, 'VIN must be all in uppercase')
      .matches(
        /^(\S+$)/,
        '* This field cannot contain only blankspaces'
      ),
  });

  const secondValidationSchema = Yup.object().shape({
    year: Yup.number()
      .required('This field is required!'),
    make: Yup.string().required('This field is required!'),
    model: Yup.string().required('This field is required!'),
    stated_value: Yup.string().required('This field is required!'),
    loss_payee: Yup.string(),
    bodytype: Yup.string().required('This field is required!'),
  });

  async function getVehicleData(vin) {
    if (isNonOwned && !vin) return { type: undefined};
    var year;
    var type;
    var model;
    var make;
    var class_value;

    await axios
      .get(
        `https://vpic.nhtsa.dot.gov/api/vehicles/decodevin/${vin}?format=json`
      )
      .then((r) => {
        for (let i = 0; i < r.data.Results.length; i++) {
          if (r.data.Results[i].Variable === 'Model Year') {
            year = r.data.Results[i].Value;
          }
        }

        for (let i = 0; i < r.data.Results.length; i++) {
          if (r.data.Results[i].Variable === 'Make') {
            make = r.data.Results[i].Value;
          }
        }

        for (let i = 0; i < r.data.Results.length; i++) {
          if (r.data.Results[i].Variable === 'Model') {
            model = r.data.Results[i].Value;
          }
        }

        for (let i = 0; i < r.data.Results.length; i++) {
          if (r.data.Results[i].Variable === 'Vehicle Type') {
            type = r.data.Results[i].Value;
          }
        }

        for (let i = 0; i < r.data.Results.length; i++) {
          if (
            r.data.Results[i].Variable ===
            'Gross Vehicle Weight Rating From'
          ) {
            class_value = r.data.Results[i].ValueId;
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });

    return {
      type,
      year:
        year !== null
          ? year
          : modal.data && modal.data.year
            ? modal.data.year
            : '',
      model:
        model !== null
          ? model
          : modal.data && modal.data.model
            ? modal.data.model
            : '',
      make:
        make !== null
          ? make
          : modal.data && modal.data.make
            ? modal.data.make
            : '',
      class_value:
        class_value !== null
          ? class_value
          : modal.data && modal.data.class_value
            ? modal.data.class_value
            : '',
    };
  }

  return (
    <Fragment>
      {modal.name === 'trailer_modal' && modal.stage === 1 && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>
                {modal.mode === 'edit' ? 'Edit ' : 'Add '}
                Trailer
              </div>
              <div className={styles.line} />
              <Formik
                validationSchema={firstValidationSchema}
                initialValues={{
                  vin:
                    modal.data && modal.data['VIN']
                      ? modal.data['VIN']
                      : '',
                }}
                onSubmit={async (values, { setErrors }) => {
                  setLoading(true);
                  const res = await getVehicleData(values.vin);
                  if (
                    modal.data.type === 'trailer' &&
                    res.type === 'TRUCK'
                  ) {
                    setLoading(false);

                    return setErrors({
                      vin: 'You are trying to add a vin that belongs to a VEHICLE under the trailers section. Please add under the vehicles section.',
                    });
                  }

                  if (
                    modal.data.type === 'vehicle' &&
                    res.type === 'TRAILER'
                  ) {
                    setLoading(false);

                    return setErrors({
                      vin: 'You are trying to add a vin that belongs to a TRAILER under the vehicles section. Please add under the trailers section.',
                    });
                  }
                  setLoading(false);

                  setModal({
                    name: 'trailer_modal',
                    stage: 2,
                    mode: modal.mode,
                    data: { ...modal.data, ...res, vin: values.vin },
                    action: modal.action,
                  });
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                  values,
                }) => (
                  <Fragment>
                    <Form
                      className={styles.form}
                      onSubmit={handleSubmit}
                    >
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="vin"
                          type="text"
                          label="VIN"
                          placeholder="VIN"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.vin}
                          touched={touched.vin}
                          required
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <div className={styles.checkboxContainer}>
                          <label>
                            <input
                              type="checkbox"
                              checked={isNonOwned}
                              onChange={(e) => {
                                setIsNonOwned(e.target.checked);
                              }}
                            />
                            <span>Non-Owned Trailer</span>
                          </label>
                        </div>
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={{ justifyContent: 'flex-end' }}
                    >
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal('')}
                        >
                          Cancel
                        </button>
                        <button
                          className={styles.save}
                          onClick={!loading ? submitForm : null}
                          style={
                            loading
                              ? { cursor: 'default' }
                              : { cursor: 'pointer' }
                          }
                        >
                          {loading ? (
                            <img
                              src={loaderImage}
                              alt="loader"
                              className={styles.loader}
                            />
                          ) : (
                            'Next'
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}

      {modal.name === 'trailer_modal' && modal.stage === 2 && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>
                {modal.mode === 'edit' ? 'Edit ' : 'Add '}
                Trailer
              </div>
              <div className={styles.line} />
              <Formik
                validationSchema={secondValidationSchema}
                initialValues={{
                  year:
                    modal.data && modal.data.year
                      ? modal.data.year
                      : '',
                  make: isNonOwned ? "Non-Owned" : (modal.data ? modal.data.make : ''),
                  model: modal.data ? modal.data.model : '',
                  stated_value,
                  status: modal.data.active,
                  loss_payee:
                    modal.data && modal.data.loss_payee
                      ? modal.data.loss_payee
                      : '',
                  bodytype:
                    modal.data && modal.data.bodytype
                      ? modal.data.bodytype
                      : '',
                  value: modal.data.value ? modal.data.value : '',
                }}
                onSubmit={async (values) => {
                  setLoading(true);

                  if (values.stated_value !== '') {
                    values.stated_value =
                      values.stated_value.replaceAll(/\D/g, '');
                  }

                  if (values.status === 'true') {
                    values.active = true;
                  }

                  if (values.status === 'false') {
                    values.active = false;
                  }

                  if (modal.mode !== 'run_quote') {
                    if (modal.data && modal.data.id) {
                      await axios
                        .patch(`/api/vehicle/${modal.data.id}`, {
                          vin: modal.data.vin,
                          year: values.year,
                          make: values.make,
                          model: values.model,
                          stated_value: values.stated_value,
                          loss_payee: values.loss_payee,
                          active: values.active,
                          type: modal && modal.data.type,
                          bodytype: values.bodytype,
                        })
                        .then((res) => {
                          setLoading(false);
                          setModal({});

                          context.notification.show(
                            'Vehicle updated successfully!',
                            'success',
                            true,
                            'toast',
                            'check-circle'
                          );

                          modal.action();
                        })
                        .catch((err) => {
                          setLoading(false);
                          setModal({});

                          context.notification.show(
                            err.response.data.message,
                            'error',
                            true,
                            'toast',
                            'x-circle'
                          );
                        });
                    } else {
                      await axios
                        .post(`/api/vehicle`, {
                          type: 'trailer',
                          vin: modal.data.vin ? modal.data.vin : '',
                          year: values.year,
                          make: values.make,
                          model: values.model,
                          stated_value: values.stated_value,
                          loss_payee: values.loss_payee,
                          bodytype: values.bodytype,
                          active: values.active,
                          company_id,
                        })
                        .then((res) => {
                          setLoading(false);
                          setModal({});

                          context.notification.show(
                            'Vehicle created successfully!',
                            'success',
                            true,
                            'toast',
                            'check-circle'
                          );

                          modal.action();
                        })
                        .catch((err) => {
                          setLoading(false);
                          setModal({});
                          console.log(err);

                          context.notification.show(
                            err.response.data.message,
                            'error',
                            true,
                            'toast',
                            'x-circle'
                          );
                        });
                    }
                  } else {
                    await axios
                      .post(`/api/vehicle`, {
                        type: 'trailer',
                        vin: modal.data.vin ? modal.data.vin : '',
                        year: values.year,
                        make: isNonOwned ? 'Non-Owned' : values.make,
                        model: values.model,
                        stated_value: values.stated_value,
                        bodytype: values.bodytype,
                        loss_payee: values.loss_payee,
                        active: values.active,
                        company_id: modal.data.company_id,
                      })
                      .then((res) => {
                        setLoading(false);
                        setModal({});

                        context.notification.show(
                          'Vehicle created successfully!',
                          'success',
                          true,
                          'toast',
                          'check-circle'
                        );

                        modal.action({
                          type: modal && modal.data.type,
                          vin: modal.data.vin ? modal.data.vin : '',
                          year: values.year,
                          make: values.make,
                          model: values.model,
                          stated_value: values.stated_value,
                          class: values.class,
                          bodytype: values.bodytype,
                          active: values.active,
                          company_id: modal.data.company_id,
                        });
                      })
                      .catch((err) => {
                        setLoading(false);
                        setModal({});
                        console.log(err);

                        context.notification.show(
                          err.response.data.message,
                          'error',
                          true,
                          'toast',
                          'x-circle'
                        );
                      });
                  }
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                  values
                }) => (
                  <Fragment>
                    <Form
                      className={styles.form}
                      onSubmit={handleSubmit}
                    >
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="bodytype"
                          type="select"
                          label="Body Type"
                          placeholder="Select trailers's body type"
                          handleChange={(event) => {
                            handleChange(event);
                            setBodyTypeOptions(event.target.value);
                          }}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.bodytype}
                          touched={touched.bodytype}
                          required
                          options={trailersBodytype}
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <div className={styles.fieldColumn}>
                          <FieldInput
                            id="year"
                            type="text"
                            label="Year"
                            placeholder="Year"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.year}
                            touched={touched.year}
                            required
                            disabled={!isNonOwned}
                          />
                           {values?.year && new Date().getFullYear() - Number(values.year) > 23 && (
                            <div className={styles.helperText}>
                              Some carriers don't accept vehicles older than 23 years
                            </div>
                          )} 
                        </div>
                        {/* <FieldInput
                          id="year"
                          type="select"
                          label="Year"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.year}
                          touched={touched.year}
                          required
                          options={
                            bodyTypeOptions === "refrigerated_van_trailer"
                              ? yearOptions10Years
                              : yearOptions20Years
                          }
                        /> */}
                        <FieldInput
                          id="make"
                          type="text"
                          label="Make of Manufacturer"
                          placeholder="Make"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.make}
                          touched={touched.make}
                          required
                          disabled={!isNonOwned}
                        />
                        <FieldInput
                          id="model"
                          type="text"
                          label="Model"
                          placeholder="Model"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.model}
                          touched={touched.model}
                          required
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="stated_value"
                          type="currency"
                          label="Value"
                          placeholder="Value"
                          handleChange={(event) => {
                            handleChangeStatedValue(
                              event,
                              handleChange
                            );
                          }}
                          value={stated_value}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.stated_value}
                          touched={touched.stated_value}
                          required
                        />
                        <FieldInput
                          id="loss_payee"
                          type="text"
                          label="Loss Payee"
                          placeholder="Loss Payee"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.loss_payee}
                          touched={touched.loss_payee}
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        {modal.mode === 'edit' ? (
                          <FieldInput
                            id="status"
                            type="select"
                            label="Status"
                            placeholder="Insert vehicle's status"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.status}
                            touched={touched.status}
                            required
                            options={[
                              {
                                value: true,
                                label: 'Active',
                              },
                              {
                                value: false,
                                label: 'Inactive',
                              },
                            ]}
                          />
                        ) : null}
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={{ justifyContent: 'flex-end' }}
                    >
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal('')}
                        >
                          Cancel
                        </button>
                        <button
                          className={styles.save}
                          onClick={!loading ? submitForm : null}
                          style={
                            loading
                              ? { cursor: 'default' }
                              : { cursor: 'pointer' }
                          }
                        >
                          {loading ? (
                            <img
                              src={loaderImage}
                              alt="Loader"
                              className={styles.loader}
                            />
                          ) : (
                            'Save'
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
